<ng-container *ngIf="params">
	<mat-checkbox
		[disabled]="isDisabled()"
		[ngModel]="isChecked()"
	>{{getValue()}}</mat-checkbox>
</ng-container>
